import cx from 'classnames';
import { node } from 'prop-types';
import React, { forwardRef } from 'react';

const HeaderMenuList = forwardRef(({ listItems }, ref) => (
  <div
    className={cx(
      'resourceCenterHeaderMenu',
      'flex',
      'fixed w-full flex-col overflow-hidden border-t-[1px] border-solid bg-white',
      'bottom-0 left-0 top-[4.5rem] z-[4] border-slate-lighter-90',
      'lg:absolute lg:top-[5.375rem] lg:right-[12.875rem] lg:h-auto lg:w-[17rem] lg:rounded-md',
      'lg:left-[initial] lg:bottom-[initial] lg:shadow-[0_4px_16px_#E9EBED]',
      'lg:border-0'
    )}
    ref={ref}
    data-tp-id='gen-div-b3ebcf92-f761-4e02-9679-030a67e4dd49'
  >
    {listItems}
  </div>
));

HeaderMenuList.propTypes = {
  listItems: node,
};

export default HeaderMenuList;
